import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SelectListComponent } from './select-list.component';

import { MatSelectModule } from '@angular/material/select';
import { SelectListService } from './services/select-list.service';

//Translation
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory, AppTranslateService } from './../../translate/translate.service';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    SelectListComponent
  ],
  exports: [
    SelectListComponent
  ],
  providers : [
    SelectListService]
})
export class SelectListModule {}
